// extracted by mini-css-extract-plugin
export default {"model":"styles_model__ibg0r","divContainer":"styles_divContainer__ZSGHf","video":"styles_video__OiEb5"};